import { BuyerUserRole } from '@choco-admin/types';

export interface BuyerSelectOption {
  value: string;
  label: string;
  disabled?: boolean;
  metaData?: {
    rolesEnabled?: boolean;
    buyerUserRole?: BuyerUserRole;
    fullAddress?: string;
  };
}

export const ROLE_LABELS: Record<BuyerUserRole, string> = {
  [BuyerUserRole.ADMIN]: 'Admin',
  [BuyerUserRole.STAFF]: 'Staff',
  [BuyerUserRole.CONTRIBUTOR]: 'Contributor',
  [BuyerUserRole.SUPPORT]: 'Support',
  [BuyerUserRole.DEFAULT]: 'Select role...',
};

export interface BuyerLinkingProps {
  onLinkedBuyersChange: (newLinkedBuyers: BuyerSelectOption[]) => void;
  onRemoveLinkedBuyer: (buyer: BuyerSelectOption) => void;
  onBuyerUserRoleChange: (buyer: BuyerSelectOption) => void;
  linkedBuyers: BuyerSelectOption[];
  userName: string;
  isUpdateForm?: boolean;
  userId?: string | null;
  disabled?: boolean;
}
